// extracted by mini-css-extract-plugin
export default {"Desktop":"Desktop_Desktop__A9gYN","Desktop__icons":"Desktop_Desktop__icons__iAOan","Desktop__iconsRight":"Desktop_Desktop__iconsRight__y54s0"};